import type { ReactNode } from 'react';

/** Full composition everywhere except the deliberately cropped history cards. */
export function FullCompositionViewer({ src, alt, className = '', children }: { src: string; alt: string; className?: string; children?: ReactNode }) {
  return <figure className={`composition-viewer ${className}`}><img src={src} alt={alt} />{children && <figcaption>{children}</figcaption>}</figure>;
}
